import React from 'react';
import { Stack, IconButton } from '@mui/material';

import { DownloadIcon, ReplayIcon } from '@/assets/icons';
import { StyledTooltip } from '@/modules/common/components/StyledTooltip';
import { OverflowTypography } from '@/modules/common/components/OverflowTypography';

interface FileActionsProps {
  fileName: string;
  fileType: 'json' | 'mdb';
  onUpload: () => void;
  onDownload: () => void;
  onReset: () => void;
  disableUpload?: boolean;
  disableReset?: boolean;
}

const FileActions: React.FC<FileActionsProps> = ({
  fileName,
  fileType,
  onUpload,
  onDownload,
  onReset,
  disableUpload = false,
  disableReset = false,
}) => (
  <Stack direction='row' alignItems='center' justifyContent='space-between' gap={1}>
    <Stack direction='row' alignItems='center' maxWidth='70%' gap={1}>
      <StyledTooltip title='Revert' placement='bottom'>
        <span>
          <IconButton onClick={onReset} disabled={disableReset}>
            <ReplayIcon />
          </IconButton>
        </span>
      </StyledTooltip>

      <OverflowTypography>
        {fileName}.{fileType}
      </OverflowTypography>
    </Stack>
    <Stack direction='row'>
      <Stack direction='row' alignItems='center' justifyContent='space-between' gap={1}>
        <StyledTooltip title='Upload' placement='bottom'>
          <span>
            <IconButton onClick={onUpload} disabled={disableUpload}>
              <DownloadIcon sx={{ transform: 'rotate(180deg)' }} />
            </IconButton>
          </span>
        </StyledTooltip>
        <input type='file' accept={`.${fileType}`} hidden />
      </Stack>
      <StyledTooltip title='Download' placement='bottom'>
        <IconButton onClick={onDownload}>
          <DownloadIcon />
        </IconButton>
      </StyledTooltip>
    </Stack>
  </Stack>
);

export default FileActions;
